import { useQuery } from "@tanstack/react-query";
import { extractQueryState } from "../../helpers/extract-query-state";
import { PropertyStatusItemDto } from "@shared/apis/sidekick/generated";
import { getPropertyApiClient } from "@shared/apis/sidekick/api-factories";

const GET_CMA_QUERY_KEY = "get-listing-statuses";
const CACHE_TIME_IN_MS = 1000 * 60 * 10; // 10 minutes

export function useGetPropertyStatuses(props?: {
  onSuccess?: (data: Array<PropertyStatusItemDto>) => void;
}) {
  const { onSuccess } = props || {};
  const api = getPropertyApiClient();

  const query = useQuery({
    queryKey: [GET_CMA_QUERY_KEY],
    queryFn: async () => {
      const response = await api.propertyControllerGetPropertyStatuses();
      if (onSuccess) {
        onSuccess(response);
      }
      return response;
    },
    enabled: true,
    refetchOnWindowFocus: false,
    gcTime: CACHE_TIME_IN_MS,
    staleTime: CACHE_TIME_IN_MS,
  });

  return extractQueryState(query);
}
